import { render, staticRenderFns } from "./adsCouse.vue?vue&type=template&id=a3db389e&"
import script from "./adsCouse.vue?vue&type=script&lang=js&"
export * from "./adsCouse.vue?vue&type=script&lang=js&"
import style0 from "./adsCouse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports